import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { useDispatch } from 'react-redux';
import { minimalTheme } from './styles/theme';
import { ProgressChartLoader } from './views/progress/ChartLoader';
import { ProductivityChartLoader } from './views/productivity/ChartLoader';
import { CostsChartLoader } from './views/costs/ChartLoader';
import { Activityresume } from './views/activity-resume';
import { setIdConnection, setToken, setModuleId, setUserId } from './store/slices/auth';
import ProvidersView from './views/providers';
import { DelayDashboard } from './views/delay-dashboard';
import { ProjectsLoader } from './views/ro/ProjectsLoader';
import { AttendanceDashboard } from './views/attendance';
import { PaymentSlipts } from './views/payment-slipts-new-platform';
import { ProfitDashboard } from './views/profit/ProfitDashboard';


const URLParamsHandler = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const connectionId = searchParams.get('connectionId');
    if (connectionId) {
      dispatch(setIdConnection(connectionId));
    }
    const token = searchParams.get('token');
    if (token) {
      dispatch(setToken(token));
    }
    const moduleId = searchParams.get('moduleId');
    if (moduleId) {
      dispatch(setModuleId(moduleId));
    }
    const userId = searchParams.get('userId');
    if (userId) {
      dispatch(setUserId(userId));
    }
    if (!token) {
      console.warn('Token no encontrado en la URL');
    }
    if (!moduleId) {
      console.warn('ModuleId no encontrado en la URL');
    }

  }, [location, dispatch]);

  return null;
}

const App = () => {

  return (
    <ThemeProvider theme={minimalTheme}>
      <CssBaseline />
      <Router>
        <URLParamsHandler />
        <Routes>
          <Route path="/resumen-actividad" element={<Activityresume />} />
          <Route path="/grafico-progreso" element={<ProgressChartLoader />} />
          <Route path="/grafico-productividad" element={<ProductivityChartLoader />} />
          <Route path="/grafico-costos" element={<CostsChartLoader />} />
          <Route path="/proveedores" element={<ProvidersView />} />
          <Route path="/cuentas-x-pagar" element={<DelayDashboard key='pagar' view={0} />} />
          <Route path="/cuentas-x-cobrar" element={<DelayDashboard key='cobrar' view={1} />} />
          {/* <Route path="/projects" element={<ProjectsLoader />} /> */}
          <Route path="/resultados-operativos-proyectos/:projectId/*" element={<ProjectsLoader />} />


          <Route path="/asistencia" element={<AttendanceDashboard />} />

          <Route path="/boletas-nuevo" element={<PaymentSlipts />} />

          <Route path="/lucro" element={<ProfitDashboard />} />

        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;